import { render } from "./HighestRatedModelTyres.vue?vue&type=template&id=47d70d77"
import script from "./HighestRatedModelTyres.vue?vue&type=script&lang=js"
export * from "./HighestRatedModelTyres.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__